import Components from "slotworks/components/components";
import Contract from "slotworks/utils/contract";

export function JumpstartSpinCommand(): Contract<void> {
    return Components.matrix.startTransition(true);
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/commands/comms/jumpstart-spin-command.ts